module.exports = __webpack_public_path__ + "img/profile.2fb9d2c0.jpg";